import type { SidebarNavGroupItem, SidebarNavItem, SidebarUser } from './sidebar.types';

export const SIDEBAR_NAV_ICON_CLASS = 'h-[16px] w-[16px] flex-shrink-0';
export const SIDEBAR_COLLAPSED_NAV_ICON_CLASS = 'h-[19px] w-[19px] flex-shrink-0';

export function sidebarUserInitials(firstName?: string, lastName?: string) {
  const first = firstName?.trim().charAt(0) ?? '';
  const last = lastName?.trim().charAt(0) ?? '';
  return `${first}${last}`.toUpperCase() || 'I';
}

export function sidebarUserFromName(
  firstName: string | undefined,
  lastName: string | undefined,
  roleLabel: string | undefined,
): SidebarUser {
  const displayName = [firstName, lastName].filter(Boolean).join(' ').trim() || 'Team member';
  return {
    displayName,
    roleLabel: roleLabel ?? 'Team member',
    initials: sidebarUserInitials(firstName, lastName),
  };
}

export function isSidebarGroupActive(item: SidebarNavGroupItem) {
  return item.active ?? item.children.some((child) => child.active);
}

export function sidebarActiveGroupIds(items: SidebarNavItem[]) {
  return items
    .filter((item): item is SidebarNavGroupItem => item.type === 'group' && isSidebarGroupActive(item))
    .map((item) => item.id);
}
